// Desc: array utils

interface GameTypes {
  [key: string]: string
}

export function findKeyByValue(gameTypes: GameTypes, value: string): string | null {
  let result: string | null = null
  Object.keys(gameTypes).forEach((key) => {
    if (gameTypes[key] === value) result = key
  })
  return result
}
